import { AbstractGoHeuristic } from '../AbstractGoHeuristic';
import { TriangularGoRules } from './TriangularGoRules';
export class TriangularGoHeuristic extends AbstractGoHeuristic {
    constructor() {
        super(TriangularGoRules.get());
    }
}
